export class Tabs {
  constructor() {
    this.$triggers = $('.tab-trigger');
    this.$tabsContainer = $('.tab-block-no-wrap');
    this.$button = $('.btn--submit');
  }

  _placeForm($el) {
    this.constructor();

    let index = $el.attr('index');
    let toScroll = this.$tabsContainer.width() * index;
    this.$tabsContainer.animate({
      scrollLeft: toScroll
    }, 500, 'swing');
    this.$button.attr('disabled', false);
  }

  _checkForSelected() {
    let $checked;
    this.$triggers.each(function() {
      if( $(this).is(':checked') ) {
        $checked = $(this);
      }
    });
    if($checked != undefined) {
      this.$tabsContainer.slideDown(function() {
        $(this).removeClass('hide');
      });
      this._placeForm($checked);
    }
  }

  init() {
    this.constructor();
    self = this;
    let resizeTimer;

    self._checkForSelected();

    this.$triggers.on('change', function() {
      self.$tabsContainer.slideDown(function() {
        $(this).removeClass('hide');
      });
      if( $(this).is(':checked') ) {
        self._placeForm($(this));
      }
    });

    $(window)
    .on('resize', function(event) {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        self._checkForSelected();
      }, 250);
    });
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/utilities/src/tabs.js